import sysTaskList from './list.vue'
import sysTaskedit from './edit.vue'
import sysTaskInfo from './info.vue'
import sysMyTaskList from './mySysTask/list.vue'





let a = Object.assign({ sysTaskList,sysTaskedit,sysTaskInfo,sysMyTaskList})
export default a
